import { useNavigate } from 'react-router-dom';
import { channelNavigateTo, isDouyinAppChannel } from '@/channels';
import { LOGIN_UNIONPAY } from '@/constants/path';

const useNavigateToLogin = () => {
  const navigate = useNavigate();

  return (redirectUrl = '') => {
    if (isDouyinAppChannel()) {
      channelNavigateTo(
        `/pages/login/index?redirectUrl=${encodeURIComponent(
          redirectUrl ? redirectUrl : location.pathname + location.search,
        )}`,
        {
          redirect: true,
        },
      );
    } else {
      const searchUrl = redirectUrl ? `?redirectUrl=${encodeURIComponent(redirectUrl)}` : '';

      navigate(`${LOGIN_UNIONPAY}${searchUrl}`);
    }
  };
};

export default useNavigateToLogin;
